import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux'
import { Toaster } from 'react-hot-toast'
import store from './store/index'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <App />
    <Toaster
  position="top-right"
  toastOptions={{
    style: {
      background: 'var(--color-card-bg)',
      color: 'var(--color-text-primary)',
      border: '1px solid var(--color-border)',
      borderRadius: '12px',
      padding: '12px 16px',
      fontSize: '14px',
      fontWeight: '600',
      boxShadow: '0 8px 24px rgba(0,0,0,0.06)',
    },

    success: {
      style: {
        background: '#E9F5F0', // soft sage
        color: '#2D4C42',
        border: '1px solid #B3D1C6',
      },
      iconTheme: {
        primary: '#8AA78F', // muted sage
        secondary: '#ffffff',
      },
    },

    error: {
      style: {
        background: '#FDEDEA', // soft terracotta blush
        color: '#5C2C28',
        border: '1px solid #E3B2AD',
      },
      iconTheme: {
        primary: '#A6563F', // terracotta
        secondary: '#ffffff',
      },
    },

    warning: {
      style: {
        background: '#FFF9EC', // soft parchment
        color: '#6D5C5B',       // dusty taupe
        border: '1px solid #EAD3B5',
      },
      iconTheme: {
        primary: '#D6A660', // golden tan
        secondary: '#fff',
      },
    },

    info: {
      style: {
        background: '#F2F7FB', // soft powder blue
        color: '#3E2C2A',
        border: '1px solid #C4D7E2',
      },
      iconTheme: {
        primary: '#8AA0B2', // desaturated denim
        secondary: '#fff',
      },
    },

    neutral: {
      style: {
        background: '#F4F1EE',
        color: '#3E2C2A',
        border: '1px solid #D7CCC8',
      },
      iconTheme: {
        primary: '#A6563F',
        secondary: '#fff',
      },
    },
  }}
/>


  </Provider>
);

reportWebVitals();
